import React, { useState } from "react";
import './FollowScreenCard.css';
import { getFollowCount } from "utilities/js/callouts/CalloutFactory";
import CookieManager from "utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import LoadingDisplay from "./LoadingDisplay";
import DetailPanel from "./DetailPanel";
import FollowPanel from "./FollowPanel";
import getURLParam from "utilities/js/ParameterRetrieval";
import { useQuery } from "@tanstack/react-query";
import InboxControl from "components/account-screen/InboxControl";

let cookieManager = new CookieManager();

const FollowScreenCard = (props) => {
    
    const currentScreen = getURLParam('screen');

    const [displayFollowPanel, setDisplayFollowPanel] = useState(false);
    const [defaultPanelTab, setDefaultPanelTab] = useState();



    let followCounts = {following: (<LoadingDisplay></LoadingDisplay>), followers: (<LoadingDisplay></LoadingDisplay>)};
    const followCountResponse = useQuery({
        queryKey: ['followCount'], 
        queryFn: () => getFollowCount({list: 'all'}), 
        staleTime: 60 * 1000,
        retry: false
    });

    if(followCountResponse.data){
        console.log(followCountResponse.data)
        followCounts = followCountResponse.data;
    }else if(followCountResponse.isError){
        followCounts = {following: 'N/A', followers: 'N/A'};
        console.log('error retrieving follow counts...')
    }

    const username = cookieManager.getValue(Constants.COOKIE_USERNAME_KEY);
    const email = cookieManager.getValue(Constants.COOKIE_USER_EMAIL_KEY);


    
    
    function openFollowPanel(event){
        setDefaultPanelTab(event.currentTarget.dataset.link);
        setDisplayFollowPanel(true);
    }
    
    function closeFollowPanel(){
        setDisplayFollowPanel(false);
    }

    function getInboxControl(){
        if(currentScreen === Constants.SCREEN_NAME_PERSONAL && props.onSettingsClick){
            return (
                <InboxControl standalone="true" notifications={props.notifications}></InboxControl>
            )
        }
    }
    
    function getDisplay(){
        if(followCountResponse.isLoading){
            return (
                <div className="nav-panel">
                    <LoadingDisplay isLoading={followCountResponse.isLoading}></LoadingDisplay>
                </div>
            )
        }else{
            
            return (
                <div className="nav-panel">
                    <div className="follow-panel-top">
                        <div className="follow-panel-user-info">
                            <div className="follow-panel-header">{username}</div>
                            <div className="follow-panel-subheader">{email}</div>
                        </div>
                        <div className="follow-panel-actions">
                            {getInboxControl()}
                        </div>

                    </div>
                    
                    <div className="follow-panel-counts">
                        <div className="follow-panel-link" data-link="following" onClick={openFollowPanel}>{followCounts.following} Following</div>
                        <div className="follow-panel-link" data-link="followers" onClick={openFollowPanel}>{followCounts.followers} Followers</div>
                    </div>
                </div>
            )
        }
    }
        
        
    return (<>
        {getDisplay()}
        
        <DetailPanel shouldDisplay={displayFollowPanel} headerText="Follow" closePanel={closeFollowPanel} showBack="true" hideFooter="true">
            <FollowPanel defaultTab={defaultPanelTab}></FollowPanel>
        </DetailPanel>
    </>)
    
}

export default FollowScreenCard;